/**
 * Module-level TanStack QueryClient singleton.
 *
 * Lives outside <QueryProvider> so non-Svelte modules (the WS singleton in
 * ws-client.ts, the auth store, etc.) can invalidate caches without needing
 * a component context. Defaults are kept here too so the provider component
 * is just a thin <QueryClientProvider> wrapper.
 */

import { QueryClient } from '@tanstack/svelte-query';
import { ApiError } from '@/lib/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      }
    }
  }
});
